import axios from 'axios'
import security from '@/services/security.js'

export default {
  get (courseKey, courseScouterType) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/pack/' + courseScouterType + '/' + courseKey, config)
      .then(response => {
        return response.data.Groups
      })
  },
  getMgmt (courseKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/pack/mgmt/' + courseKey, config)
      .then(response => {
        return response.data
      })
  },
  updateBatch (courseKey, packingLists, removedgroupIds) {
    const config = { headers: security.getAuthHeader() }
    const msg = { PackingLists: packingLists, RemovedGroups: removedgroupIds }
    return axios.put('/pack/' + courseKey, msg, config)
      .then(response => {
        return response.data
      })
  },
  deleteItem (packingListGroupId, itemId) {
    const config = { headers: security.getAuthHeader() }
    return axios.delete('/pack/' + packingListGroupId + '/' + itemId, config)
      .then(response => {
        return response.data
      })
  },
  addItem (packingListGroupId, desc) {
    const config = { headers: security.getAuthHeader() }
    const msg = { GroupId: packingListGroupId, Description: desc }
    return axios.post('/pack', msg, config)
      .then(response => {
        return response.data
      })
  },
  updateItem (packingListItem) {
    const config = { headers: security.getAuthHeader() }
    return axios.put('/pack', packingListItem, config)
      .then(response => {
        return response.data
      })
  },
  deleteCategory (coursePackingListId, packingListGroupId) {
    const config = { headers: security.getAuthHeader() }
    return axios.delete('/pack/' + coursePackingListId + '/category/' + packingListGroupId, config)
      .then(response => {
        return response.data
      })
  },
  updateCategory (coursePackingListId, packingListGroup) {
    const config = { headers: security.getAuthHeader() }
    return axios.put('/pack/' + coursePackingListId + '/category', packingListGroup, config)
      .then(response => {
        return response.data
      })
  }
}
